var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMathPlus = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "math-plus 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4999 2.40039C8.11329 2.40039 7.7999 2.71379 7.7999 3.10039V7.30039H3.5999C3.21331 7.30039 2.8999 7.61378 2.8999 8.00039C2.8999 8.387 3.21331 8.70039 3.5999 8.70039H7.7999V12.9004C7.7999 13.287 8.11329 13.6004 8.4999 13.6004C8.88651 13.6004 9.1999 13.287 9.1999 12.9004V8.70039H13.3999C13.7865 8.70039 14.0999 8.387 14.0999 8.00039C14.0999 7.61378 13.7865 7.30039 13.3999 7.30039H9.1999V3.10039C9.1999 2.71379 8.88651 2.40039 8.4999 2.40039Z",
    fill: "#45A9EF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMathPlus);
export default ForwardRef;